<template>
  <button v-if="!url" aria-haspopup="true" :aria-expanded="isActive">
    <i :class="icon" aria-hidden></i>
    <span class="name">{{ name }}</span>
    <span class="excerpt">{{ excerpt }}</span>
    <i class="far fa-chevron-right" aria-hidden></i>
  </button>
  <a v-else :href="url">
    <i :class="icon" aria-hidden></i>
    <span class="name">{{ name }}</span>
    <span class="excerpt">{{ excerpt }}</span>
  </a>
</template>

<script>
  export default {
    name: 'MobileMenuButton',
    props: {
      name: String,
      isActive: Boolean,
      icon: String,
      excerpt: String, 
      url: String,
    }
  }
</script>

<style lang="scss" scoped>
  button, a  {
    width: 100%;
    display: grid;
    grid-template-columns: 40px 1fr 10px;
    grid-column-gap: 15px;
    grid-template-areas: 
      "icon name arrow"
      "icon excerpt arrow";

    text-align: left;
    align-items: center;
    padding: 20px 20px 20px 30px !important; /* OLD SeaGOV banner has some super strong css  */
    border: 0px;
    background: #fff !important; /* OLD SeaGOV banner has some super strong css  */
    color: #000;

    &:hover {
      text-decoration: none;
    }

    svg:first-child {
      grid-area: icon;
      color: #fff;
      background: #0046ad;
      width: 40px;
      height: 40px;
      padding: 8px;
      border-radius: 50px;
    }

    .name {
      grid-area: name;
      text-transform: uppercase;
      font-weight: 600;
    }

    .excerpt {
      grid-area: excerpt;
      font-size: .875em;
      font-weight: 400;
    }

    .fa-chevron-right {
      grid-area: arrow;
    }
  }

  /* MAC FIX Seattle Font */
  .mac.notFF button span {
    padding-top: 5px;
  }
</style>
